"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Base = _interopRequireDefault(require("./Base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class Pizza extends _Base.default {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "type", 'pizza');

    _defineProperty(this, "pay_for", 'average');

    _defineProperty(this, "max_flavors", 1);

    _defineProperty(this, "doughs", []);

    _defineProperty(this, "getPrice", () => {
      let doughsPrice = 0;
      let edgesPrice = 0;
      let extraIngredientsPrice = 0;
      (this.doughs || []).forEach(dough => {
        doughsPrice += +dough.price || +dough.getPrice();
      });
      (this.edges || []).forEach(edge => {
        edgesPrice += +edge.price || +edge.getPrice();
      });
      (this.extra_ingredients || []).forEach(extra => {
        extraIngredientsPrice += +extra.price || +extra.getPrice();
      });

      switch (this.pay_for) {
        case 'average':
        default:
          let precision = Math.pow(10, 2);
          let flavors = this.items.filter(flavor => flavor.getPrice() > 0);
          let flavorsQuantity = flavors.reduce((total, flavor) => total + flavor.quantity, 0);
          let flavorPrices = flavors.map(flavor => flavor.getPrice());

          if (flavorPrices.length == 0) {
            return (extraIngredientsPrice + edgesPrice) * (+this.quantity || 0);
          }

          let pizzaAveragePrice = flavorPrices.reduce((totalItem, flavorPrice) => totalItem + flavorPrice, 0) / flavorsQuantity;
          let pizzaPrice = +(Math.ceil(+(pizzaAveragePrice * precision)) / precision).toFixed(2);
          return (pizzaPrice + extraIngredientsPrice + edgesPrice + doughsPrice) * (+this.quantity || 0);
      }
    });

    _defineProperty(this, "isValid", () => {
      return this.getItemsByParam('selected', true).filter(i => i.type == 'flavor').length.between(1, this.max_flavors, true);
    });

    _defineProperty(this, "toJSON", () => {
      let me = this,
          _this = {};
      ['_id', 'ref_id', 'parent', 'position', 'type', 'pay_for', 'max_flavors', 'name', 'items', 'edges', 'extra_ingredients', 'new', 'delete', 'show', 'selected', 'quantity', 'observation', 'highlight', 'sizes', 'doughs', 'availability', 'categoryName'].map(prop => {
        _this[prop] = me[prop];
      });
      ['quantity', 'position', 'max_flavors'].map(prop => {
        if (me[prop] !== null && +me[prop] !== NaN) {
          _this[prop] = +me[prop];
        }
      });
      return _this;
    });
  }

}

exports.default = Pizza;